import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "./i18n";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { History } from "./components/History";
import { TourDates } from "./components/TourDates";
import { Members } from "./components/Members";
import { TechRider } from "./components/TechRider";
import { BookingForm } from "./components/BookingForm";
import { Footer } from "./components/Footer";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LangProvider>
      <div data-testid="crayfox-app" className="bg-[#0A0A0C] text-gray-100 min-h-screen overflow-x-clip">
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <History />
          <TourDates />
          <Members />
          <TechRider />
          <BookingForm />
        </main>
        <Footer />
        <Toaster theme="dark" position="bottom-right" />
      </div>
    </LangProvider>
  );
}
